<div *ngFor="let row of data">
    <div id="rows-title" class="flex items-center text-[#223E80] pt-4 px-8 ">
        <div class="icon p-2 bg-gray-300 flex items-center justify-center rounded-full mr-4">
            <span class="material-icons">
                {{row?.icon}}
            </span>
        </div>
        <div class="font-bold text-lg" *ngIf="row">
            <h3>
                {{utils.traslatei18n(row.title)}}
            </h3>
        </div>
    </div>
    <div id="rows-datas" class=" py-4 px-8">
        <div *ngIf="row" class="flex flex-wrap md:justify-start">
            <div *ngFor="let label of getLabels(row.data)"
                class="flex items-center lg:w-[calc(100%/3)] py-2 sm:w-[calc(100%/2)] w-full lg:justify-start">
                <h6 class="mr-2 font-normal text-sm">{{utils.traslatei18n(label)}}: </h6>
                <span class="text-base  font-medium m-6 lg:m-4">{{utils.traslatei18n(row.data[label])}}</span>
            </div>
        </div>
    </div>
    <div class="hr h-[2px] bg-gray-300"></div>
</div>
<div id="table" class="flex flex-col items-center justify-center p-4">
    <div class="flex items-center justify-center w-[100%] text-center mb-2">
        <h6 class="pb-2 border-b-2 border-[#223E80] text-[#223E80] font-medium text-base w-[35%] mx-2">
            {{utils.traslatei18n('Question')}} </h6>
        <h6 class="pb-2 border-b-2 border-[#223E80] text-[#223E80] font-medium text-base w-[35%] mx-2">
            {{utils.traslatei18n('Answer')}}</h6>
    </div>
    <div class="scroll h-[230px] text-center overflow-y-auto w-[100%]">
        <div *ngFor="let item of tableData" class="flex flex-row justify-center">
            <div class="w-[35%] flex flex-col items-center mx-2 border-b border-gray-300 py-2">
                <p class="text-sm font-normal w-[100%]   ">
                    {{(item.question | translate) | async}}</p>
            </div>
            <div *ngIf="item.questiontype ==='MultipleOptionChoice'" class="w-[35%] flex flex-col items-center mx-2 border-b border-gray-300 py-2">
                <p  *ngFor="let paragraph of item.answer| splitAnswer:';'" class="text-sm font-bold w-[100%]">
                    {{ paragraph }}
                </p>
            </div>
            <div *ngIf="item.questiontype !=='MultipleOptionChoice'" class="w-[35%] flex flex-col items-center mx-2 border-b border-gray-300 py-2">
                <p class="text-sm font-bold w-[100%]    ">
                    {{controlSplit(item.answer, item.question)}}</p>
            </div>
        </div>
    </div>
</div>
<ng-container *ngTemplateOutlet="isCEC && verbatim ? verbatimTemplate : null"></ng-container>
<ng-container *ngTemplateOutlet="showDataMining ? dataMiningTemplate : null"></ng-container>



<ng-template #verbatimTemplate>
    <div class="hr h-[2px] bg-gray-300"></div>
    <div class="flex items-center text-[#223E80] pt-4 px-8 rows-title">
        <div class="icon p-2 bg-gray-300 flex items-center justify-center rounded-full mr-4">
            <span class="material-icons">
                {{ 'chat_bubble' }}
            </span>
        </div>
        <div class="font-bold text-lg">
            <h3>
                {{ ('Verbatim' | translate) | async }}
            </h3>
        </div>
    </div>
    <div class="py-4 px-8 flex justify-center rows-datas">
        <mat-form-field appearance="outline" class="w-[75%]">
            <textarea maxlength="200" matInput cdkTextareaAutosize readonly> {{ verbatim!.verbatim | truncate : 200 }}
        </textarea>
        </mat-form-field>
    </div>
    <div class="hr h-[2px] bg-gray-300"></div>
</ng-template>

<ng-template #dataMiningTemplate>
    <div id="rows-title" class="flex items-center text-[#223E80] pt-4 px-8 ">
        <div class="icon p-2 bg-gray-300 flex items-center justify-center rounded-full mr-4">
            <span class="material-icons">
                {{'attach_file'}}
            </span>
        </div>
        <div class="font-bold text-lg" *ngIf="dataMiningForm">
            <h3>
                {{utils.traslatei18n('dataMining')}}
            </h3>
        </div>
    </div>
    <div id="rows-datas" *ngIf="dataMiningForm" [formGroup]="dataMiningForm"
        class=" ml-10 w-[90%] py-4 pl-10 grid grid-cols-8 gap-4">

        <div class="col-start-1 col-span-1 pt-5">
            <h6>Contact Reason</h6>
        </div>
        <div class="col-span-2">
            <mat-form-field class="w-[100%]" appearance="outline">
                <!-- <mat-label>Category Level 1</mat-label> -->
                <input  placeholder="reason" formControlName="contactReasonL1" matInput>
            </mat-form-field>
        </div>
        <div class="col-span-2">
            <mat-form-field class="w-[100%]" appearance="outline">
                <!-- <mat-label>Category Level 2</mat-label> -->
                <input  placeholder="reason" formControlName="contactReasonL2" matInput>
            </mat-form-field>
        </div>

        <div class="col-start-1 col-span-1 pt-5">
            <h6>Dissatisfaction Reason 1</h6>
        </div>
        <div class="col-span-2">
            <mat-form-field class="w-[100%]" appearance="outline">
                <!-- <mat-label>Category Level 1</mat-label> -->
                <input  placeholder="reason" formControlName="dissatisfacionReason1Level1" matInput>
            </mat-form-field>
        </div>
        <div class="col-span-2">
            <mat-form-field class="w-[100%]" appearance="outline">
                <!-- <mat-label>Category Level 2</mat-label> -->
                <input  placeholder="reason" formControlName="dissatisfacionReason1Level2" matInput>
            </mat-form-field>
        </div>

        <div class="col-start-1 col-span-1 pt-5">
            <h6>Dissatisfaction Reason 2</h6>
        </div>
        <div class="col-span-2">
            <mat-form-field class="w-[100%]" appearance="outline">
                <!-- <mat-label>Category Level 1</mat-label> -->
                <input  placeholder="reason" formControlName="dissatisfacionReason2Level1" matInput>
            </mat-form-field>
        </div>
        <div class="col-span-2">
            <mat-form-field class="w-[100%]" appearance="outline">
                <!-- <mat-label>Category Level 2</mat-label> -->
                <input  placeholder="reason" formControlName="dissatisfacionReason2Level2" matInput>
            </mat-form-field>
        </div>
        
        <div class="col-start-1 col-span-1 pt-5">
            <h6>Description</h6>
        </div>
        <div class="col-span-7">
            <mat-form-field class="w-[100%]" appearance="outline">
                <!-- <mat-label>Category Level 2</mat-label> -->
                <textarea cdkTextareaAutosize  placeholder="reason" formControlName="description" matInput></textarea>
            </mat-form-field>
        </div>

        <div class="col-start-1 col-span-1 pt-5">
            <h6>Name</h6>
        </div>
        <div class="col-span-2">
            <mat-form-field class="w-[100%]" appearance="outline">
                <!-- <mat-label>Category Level1</mat-label>  -->
                <input  placeholder="reason" formControlName="personEnteringInfo" matInput>
            </mat-form-field>
        </div>

        <div class="col-start-1 col-span-1 pt-5">
            <h6>Date Start</h6>
        </div>
        <div class="col-span-2">
            <!-- <mat-form-field class="w-[100%]" appearance="outline">
                <mat-label>Category Level1</mat-label>
                <input  placeholder="reason" formControlName="dtStart" matInput>
            </mat-form-field> -->
            <mat-form-field class="w-[100%]" appearance="outline">
                <!-- <mat-label>Date Start</mat-label> -->
                <input placeholder="Date" [matDatepicker]="startPicker" formControlName="dtStart" matInput>
                <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
                <mat-datepicker #startPicker></mat-datepicker>
            </mat-form-field>
        </div>
    </div>
</ng-template>